<template>
  <div
    v-if="hasAccess"
    class="fill-height"
  >
    <v-row class="d-flex justify-center fill-height">
      <v-col
        cols="12"
      >
        <v-card
          class="mx-auto"
          max-width="1920"
        >
          <v-card-title>{{ $vuetify.lang.t('$vuetify.annotationForm') }}</v-card-title>
          <v-card-text>
            <v-form>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-select
                    v-model="selected.annotation"
                    :items="annotationDataSelect"
                    :label="$vuetify.lang.t('$vuetify.annotations')"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-select
                    v-model="selected.microcontroller"
                    :items="microcontrollerDataSelect"
                    :label="$vuetify.lang.t('$vuetify.machine')"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <div class="d-flex justify-center flex-wrap">
                    <v-date-picker
                      v-model="date"
                      :show-current="true"
                      :reactive="true"
                      class="ma-2"
                      @input="haltInterval = true"
                    />
                    <v-time-picker
                      v-model="time"
                      format="24hr"
                      use-seconds
                      class="ma-2"
                      @input="haltInterval = true"
                    />
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="d-flex justify-center"
                >
                  <v-btn
                    color="primary"
                    large
                    @click="submit"
                  >
                    {{ $vuetify.lang.t('$vuetify.submit') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment';
import apiUtil from '../utils/ApiUtil';

export default {
  data: () => {
    return {
      permissionsKey: 9,
      annotationData: [],
      microcontrollerData: [],
      intervalHandler: null,
      haltInterval: false,
      time: null,
      date: null,
      selected: {
        annotation: null,
        microcontroller: null,
      },
    };
  },
  computed: {
    hasAccess() {
      return this.$store.state.user.permissions.indexOf(this.permissionsKey) >= 0;
    },
    dateTime() {
      return `${this.date} ${this.time}`;
    },
    microcontrollerDataSelect() {
      if (!this.microcontrollerData.length) {
        return [];
      }
      const result = [];
      for (const item of this.microcontrollerData) {
        result.push({ text: item.machineDisplayName, value: item.id });
      }
      return result;
    },
    annotationDataSelect() {
      if (!this.annotationData.length) {
        return [];
      }
      const result = [];
      for (const item of this.annotationData) {
        result.push({ text: item.name, value: item.id });
      }
      return result;
    },
  },
  destroyed() {
    clearInterval(this.intervalHandler);
  },
  async created() {
    this.$store.dispatch('setGlobalLoading', true);
    await this.initialize();
    this.$store.dispatch('setGlobalLoading', false);

    this.intervalHandler = setInterval(() => {
      if (!this.haltInterval) {
        this.time = moment().format('HH:mm:ss');
        this.date = moment().format('YYYY-MM-DD');
      }
    }, 1000);
  },
  methods: {
    async initialize() {
      const annotationResult = await apiUtil.getAllAnnotations();
      const microcontrollerResult = await apiUtil.getAllMicrocontroller();

      this.annotationData = annotationResult;
      this.microcontrollerData = microcontrollerResult;
    },
    async submit() {
      this.haltInterval = false;
      await apiUtil.saveAnnotationForm({ microcontroller_id: this.selected.microcontroller, annotation_id: this.selected.annotation, timestamp: moment(this.dateTime).utc().format('YYYY-MM-DD HH:mm:ss') });
    },
  },
};
</script>

<style lang="scss">
	.v-time-picker-title__time .v-picker__title__btn,
	.v-time-picker-title__time
	span {
		height: 56px !important;
	}
</style>
